<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <mat-form-field appearance="fill">
        <mat-label>{{'chon_thong_so_de_loc' | translate}}</mat-label>
        <mat-select (selectionChange)="onSelectionChange($event)"  [(ngModel)]="staticdata.field_filter" >
          <mat-option *ngFor="let item of newfields" [value]="item.field_custom">
            {{item?.field_lable ?? item.field_custom}}
          </mat-option>
          <mat-option [value]="'brand'">Thương hiệu</mat-option>
        </mat-select>
      </mat-form-field>
  
      <div class="example_btn">
        <button class="_btn d-flex justify-content-between align-items-center p-1" (click)="addItem()">
          <span>{{'them_tab_moi' | translate}}</span>
          <span class="ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span>
        </button>
      </div>
      <ul cdkDropList [style.height]="staticdata.data_list.length <= 5 ? ' auto': '300px'"
        [style.min-height]="staticdata.data_list.length <= 5?'auto': '300px'" 
        class="example-list"
        (cdkDropListDropped)="cdkDropListDropped($event)"
        >
        <li class="example-box row m-0"
          *ngFor="let item of staticdata.data_list; index as i" cdkDrag>
          <div class="col p-0 d-flex align-items-center">
            <i class="bi bi-list example-handle mr-1" cdkDragHandle></i>
            <span 
              class="p-0 m-0" 
              data-toggle="tooltip" 
              [title]="item" 
              [style.font-weight]="item === itemChoosing ? 'bold' : ''"
              (click)="itemChoosing = item; $event.stopPropagation();"
            >
              {{ (item['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component).length >= 18 ? ((item['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component) | slice:0:15) + '...' : item['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component }}</span>
          </div>
          <div class="colp-0">
            <span nz-icon nzType="dash" nzTheme="outline" class="_icon_option"
              (click)="$event.stopPropagation();onContextMenu($event, menuObjectBlockFooter)"></span>
          </div>
  
          <nz-dropdown-menu #menuObjectBlockFooter="nzDropdownMenu">
            <ul nz-menu [nzMode]="'vertical'">
              <li nz-menu-item class="text-danger" (click)="$event.stopPropagation();deleteItem(item)"><i
                  class="bi bi-trash mr-2"></i>
                {{'xoa' | translate}}</li>
            </ul>
          </nz-dropdown-menu>
  
          
        </li>
      </ul>
      <div *ngIf="itemChoosing" class="config-text"
        style="width: 100%; margin-top: 10px">
        <mat-form-field style="width: 100%">
          <mat-label>{{'noi_dung' | translate}}</mat-label>
          <textarea matInput
            [ngModel]="itemChoosing['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component" 
            (ngModelChange)="itemChoosing['value_' + functionService.selectedLanguageCode] = $event" 
            (blur)="updateContent()"></textarea>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>

  <ng-container *ngIf="!isViewAll  && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" >
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <ul>
          <li class="pl-2" nz-submenu nzTitle="{{'tuy_chinh_chu' | translate}}">
            <div class="container-font">
              <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
                 [staticdata]="staticdata" [textContentClass]="class['dynamic-filter__item-label']"
                [textWrapperClass]="class['dynamic-filter__item-label']"
                [isHideTextAlign]="class['dynamic-filter__container']['flex-direction'] === 'row'">
              </app-text-format-config>
            </div>
            <!-- khoang_cach_giua_cac_phan_tu -->
            <div class="font-adjusting">
              <div class="row-spacing">
                <span class="title" style="width: '50%'; display: 'inline-block'"> {{'khoang_cach_giua_cac_phan_tu' | translate}}</span>
                <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                  [ngModel]="class['dynamic-filter__container']['gap'] | vhnumber"
                   (nzBlur)="updateClass()" 
                   (ngModelChange)="class['dynamic-filter__container']['gap'] = $event + 'px'"
                   ></nz-input-number>
              </div>
              <nz-slider [nzMin]="0" 
              [ngModel]="class['dynamic-filter__container']['gap'] | vhnumber"
              (ngModelChange)="class['dynamic-filter__container']['gap'] = $event + 'px'"
                (nzOnAfterChange)="updateClass()"
                ></nz-slider>
            </div>
            <!-- khoang_cach_chu_va_nut -->
            <div class="font-adjusting">
              <div class="row-spacing">
                <span class="title" style="width: '50%'; display: 'inline-block'"> {{'khoang_cach_chu_va_nut' | translate}}</span>
                <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                  [ngModel]="class['dynamic-filter__item-label']['gap'] | vhnumber"
                   (nzBlur)="updateClass()" 
                   (ngModelChange)="class['dynamic-filter__item-label']['gap'] = $event + 'px'"
                   ></nz-input-number>
              </div>
              <nz-slider [nzMin]="0" 
              [ngModel]="class['dynamic-filter__item-label']['gap'] | vhnumber"
              (ngModelChange)="class['dynamic-filter__item-label']['gap'] = $event + 'px'"
                (nzOnAfterChange)="updateClass()"
                ></nz-slider>
            </div>

            <!-- kieu_hien_thi -->
            <div class="font-adjusting my-4">
              <div>
                <p class="title mb-1"> {{'kieu_hien_thi' | translate}}</p>
                <nz-select [(ngModel)]="class['dynamic-filter__container']['flex-direction']" (ngModelChange)="updateClass()">
                  <nz-option nzValue="column" nzLabel="{{'doc' | translate}}"></nz-option>
                  <nz-option nzValue="row" nzLabel="{{'ngang' | translate}}"></nz-option>
                </nz-select>
              </div>

              <!-- Canh lề nhóm thẻ -->
              <div *ngIf="class['dynamic-filter__container']['flex-direction'] === 'row'" class="config-font mt-4">
                <p class="mt-2 mb-3" style="line-height: normal">{{'canh_le_ngang_cho_nhom_the' | translate}}</p>
                <div class="font">
                  <button class="font-text-btn" nz-button title="flex-start" 
                    [nzType]="class['dynamic-filter__container']['justify-content'] == 'flex-start' ? 'primary' : 'default'" 
                    (click)="class['dynamic-filter__container']['justify-content'] = 'flex-start'; updateClass()">
                    <i nz-icon nzType="align-left" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button title="center"
                    [nzType]="class['dynamic-filter__container']['justify-content'] == 'center' ? 'primary' : 'default'" 
                    (click)="class['dynamic-filter__container']['justify-content'] = 'center'; updateClass()">
                    <i nz-icon nzType="align-center" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button title="flex-end"
                    [nzType]="class['dynamic-filter__container']['justify-content'] == 'flex-end' ? 'primary' : 'default'" 
                    (click)="class['dynamic-filter__container']['justify-content'] = 'flex-end'; updateClass()">
                    <i nz-icon nzType="align-right" nzTheme="outline"></i>
                  </button>
                </div>
              </div>
            </div>
            
          </li>
          <li class="pl-2" nz-submenu nzTitle="{{'tuy_chinh_nut' | translate}}" >
            <div class="row-spacing">
              <span class="title">{{'kich_thuoc' | translate}}</span>
              <nz-input-number [nzMin]="0"  [ngStyle]="{ width: '40%' }" 
                [ngModel]="class['dynamic-filter__item-checkbox']['width'] | vhnumber" 
                (nzBlur)="updateClass()" 
                (ngModelChange)="class['dynamic-filter__item-checkbox']['width'] = class['dynamic-filter__item-checkbox']['height'] = $event + 'px'">
              </nz-input-number>
            </div>

            <div class="color-pick">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input class="input-color w-50" type="button" 
                [cpOKButton]="true" [(colorPicker)]="class['dynamic-filter__item-checkbox']['background-color']"
                [style.background]="class['dynamic-filter__item-checkbox']['background-color']" 
                (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" />
            </div>
            <div class="color-pick">
              <span class="title w-50">{{'mau_icon' | translate}}</span>
              <input class="input-color w-50" type="button" 
                [cpOKButton]="true" [(colorPicker)]="class['dynamic-filter__item-checkbox']['color']"
                [style.background]="class['dynamic-filter__item-checkbox']['color']" 
                (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" />
            </div>

            
            
          </li>
        </ul>
      </li>
      <!-- Chọn thông số -->
      <li  nz-submenu nzTitle="{{'chon_thong_so' | translate }}" [(nzOpen)]="openMap.menu4"
      (nzOpenChange)="openHandler('menu4')">
        <mat-form-field appearance="fill">
          <mat-label>{{'chon_thong_so_de_loc' | translate}}</mat-label>
          <mat-select (selectionChange)="onSelectionChange($event)"  [(ngModel)]="staticdata.field_filter" >
            <mat-option *ngFor="let item of newfields" [value]="item.field_custom">
              {{item?.field_lable ?? item.field_custom}}
            </mat-option>
            <mat-option [value]="'brand'">Thương hiệu</mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container >
          <div class="example_btn">
            <button class="_btn d-flex justify-content-between align-items-center p-1" (click)="addItem()">
              <span>{{'them_tab_moi' | translate}}</span>
              <span class="ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span>
            </button>
          </div>
          <ul cdkDropList [style.height]="staticdata.data_list.length <= 5 ? ' auto': '300px'"
            [style.min-height]="staticdata.data_list.length <= 5?'auto': '300px'" 
            class="example-list"
            (cdkDropListDropped)="cdkDropListDropped($event)"
            >
            <li class="example-box row m-0"
              *ngFor="let item of staticdata.data_list; index as i" cdkDrag>
              <div class="col p-0 d-flex align-items-center">
                <i class="bi bi-list example-handle mr-1" cdkDragHandle></i>
                <span 
                  class="p-0 m-0" 
                  data-toggle="tooltip" 
                  [title]="item" 
                  [style.font-weight]="item === itemChoosing ? 'bold' : ''"
                  (click)="itemChoosing = item; $event.stopPropagation();"
                >
                  {{ (item['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component).length >= 18 ? ((item['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component) | slice:0:15) + '...' : item['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component }}</span>
              </div>
              <div class="colp-0">
                <span nz-icon nzType="dash" nzTheme="outline" class="_icon_option"
                  (click)="$event.stopPropagation();onContextMenu($event, menuObjectBlockFooter)"></span>
              </div>
  
              <nz-dropdown-menu #menuObjectBlockFooter="nzDropdownMenu">
                <ul nz-menu [nzMode]="'vertical'">
                  <li nz-menu-item class="text-danger" (click)="$event.stopPropagation();deleteItem(item)"><i
                      class="bi bi-trash mr-2"></i>
                    {{'xoa' | translate}}</li>
                </ul>
              </nz-dropdown-menu>
  
              
            </li>
          </ul>
          <div *ngIf="itemChoosing" class="config-text"
            style="width: 100%; margin-top: 10px">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="itemChoosing['value_' + functionService.selectedLanguageCode] | vhLanguage : 'value' : objectChoosing.component" 
                (ngModelChange)="itemChoosing['value_' + functionService.selectedLanguageCode] = $event" 
                (blur)="updateContent()"></textarea>
            </mat-form-field>
          </div>
        </ng-container>
      </li>


      <li nz-submenu nzTitle="{{'cau_hinh_thanh_cuon' | translate}}" nzIcon="">
        <!-- Chiều rộng -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"chieu_rong" | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="config['scrollbar']?.['width_scrollbar'] | vhnumber"
            (nzBlur)="updateConfig()"
            (ngModelChange)="config['scrollbar']['width_scrollbar'] = $event + 'px'"
          ></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzStep]="1"
              [ngModel]="config['scrollbar']?.['width_scrollbar'] | vhnumber"
              (nzOnAfterChange)="updateConfig()"
              (ngModelChange)="
                config['scrollbar']['width_scrollbar'] = $event + 'px'
              "
            ></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Chiều cao -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"chieu_cao" | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="config['scrollbar']?.['height_scrollbar'] | vhnumber"
            (nzBlur)="updateConfig()"
            (ngModelChange)="
              config['scrollbar']['height_scrollbar'] = $event + 'px'
            "
          ></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzStep]="1"
              [ngModel]="config?.['scrollbar']?.['height_scrollbar'] | vhnumber"
              (nzOnAfterChange)="updateConfig()"
              (ngModelChange)="
                config['scrollbar']['height_scrollbar'] = $event + 'px'
              "
            ></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Màu nền nút kéo -->
        <div class="color-pick mb-2">
          <span class="title w-50" style="line-height: 1.3;">{{"nut_keo" | translate}}</span>
          <input class="input-color w-50" 
            type="button" 
            [cpOKButton]="true" [(colorPicker)]="config['scrollbar']['background_color_thumb']"
            [style.background]="config['scrollbar']['background_color_thumb']" (colorPickerClose)="updateConfig()"
            [cpWidth]="'230px'" 
            />
        </div>

        <div class="color-pick">
          <span class="title w-50" style="line-height: 1.3;">{{"phan_duong_dan" | translate}}</span>
          <input class="input-color w-50" 
            type="button" 
            [cpOKButton]="true" [(colorPicker)]="config['scrollbar']['background_color_track']"
            [style.background]="config['scrollbar']['background_color_track']" (colorPickerClose)="updateConfig()"
            [cpWidth]="'230px'" 
            />
        </div>

          <!-- Bo tròn nút kéo-->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{"bo_tron_nut_keo" | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [nzMax]="10"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="config?.['scrollbar']?.['border_radius_thumb'] | vhnumber"
              (nzBlur)="updateConfig()"
              (ngModelChange)="
                config['scrollbar']['border_radius_thumb'] = $event + 'px'
              "
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [nzMax]="10"
                [ngModel]="config?.['scrollbar']?.['border_radius_thumb'] | vhnumber"
                (nzOnAfterChange)="updateConfig()"
                (ngModelChange)="
                  config['scrollbar']['border_radius_thumb'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>

          <!-- Bo tròn phần đường đi -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{"bo_tron_duong_di" | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [nzMax]="10"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="config?.['scrollbar']?.['border_radius_track'] | vhnumber"
              (nzBlur)="updateConfig()"
              (ngModelChange)="
                config['scrollbar']['border_radius_track'] = $event + 'px'
              "
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [nzMax]="10"
                [ngModel]="config?.['scrollbar']?.['border_radius_track'] | vhnumber"
                (nzOnAfterChange)="updateConfig()"
                (ngModelChange)="
                  config['scrollbar']['border_radius_track'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>

      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu10"
        (nzOpenChange)="openHandler('menu10')">
        <app-rotate-config [classRotate]="class['dynamic-filter']" [config]="config" [device]="device"  [objectChoosing]="objectChoosing" ></app-rotate-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    

   
  </div>
</div>